<div class="row container-form-list mb-4">
        <div class="col-12">
            <div class="card">
                <div class="card-header">
                    <h6 class="card-title">
                        Informe os bairros desta sub-região
                    </h6>
                </div>
                <div class="table-responsive">
                    <table class="table table-striped table-hover table-bordered">
                        <thead>
                            <tr>
                            <th class="col-delete"></th>
                            <th class="col-bairro">Bairro</th>
                            <th class="col-classificacao">Classificação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let entity of entities; let i = index">
                                <td class="col-delete">
                                    <a class="btn btn-link" (click)="delete(i)">
                                        <i class="far fa-trash-alt" aria-hidden="true"></i>
                                    </a>
                                </td>
                                <td class="col-bairro">
                                    <input type="text" class="form-control" [(ngModel)]="entity.nome" name="bairroNome_{{i}}"
                                        #bairroNome="ngModel" #inputBairroNome maxlength="255">
                                    <sgt-form-control-error
                                        *ngIf="bairroNome.errors && bairroNome.errors.maxlength"
                                        msgError="O nome deve ter no máximo 255 caracteres">
                                    </sgt-form-control-error>
                                </td>
                                <td class="col-classificacao">
                                    <select class="form-control" name="classificacaoBairro_{{i}}"
                                        [ngModel]="entity.classificacao || ''" (ngModelChange)="entity.classificacao = $event ? $event : null"
                                        #classificacaoBairro="ngModel">
                                        <option value="">Selecione a classificação...</option>
                                        <option *ngFor="let classificacao of classificacoes" [ngValue]="classificacao.id">{{classificacao.nome}}</option>
                                    </select>
                                </td>
                            </tr>
                            <tr *ngIf="entities.length === 0" class="no-record">
                                <td class="text-center" colspan="2">
                                    <i class='fas fa-info' aria-hidden='true'></i> Nenhum registro encontrado
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <button type="button" class="btn btn-primary btn-sm" (click)="insert()">
                        <i class="fas fa-plus" aria-hidden="true"></i> Adicionar
                    </button>
                </div>
            </div>
        </div>
    </div>
